import { Pill } from '@/components/ui/pill'

export type AircraftStatus = 'Active' | 'Maintenance' | 'Inactive'

const variants: Record<AircraftStatus, 'success' | 'warning' | 'error'> = {
  Active: 'success',
  Maintenance: 'warning',
  Inactive: 'error',
}

export function AircraftStatusBadge({ status }: { status: AircraftStatus | string }) {
  const variant = variants[status as AircraftStatus] ?? variants.Inactive

  return <Pill variant={variant}>{status}</Pill>
}
